﻿import { default as DsSlider } from './DsSliderWrapper';
import { goToSlide } from './ExposedFunctions';

export default DsSlider;
export { goToSlide };